import React from "react";

interface LogoProps {
  height?: number;
  showText?: boolean;
}

export function Logo({ height = 60, showText = true }: LogoProps) {
  return (
    <div className="sentinel-logo-container" style={{ display: "inline-flex", alignItems: "center", gap: "16px" }}>
      <svg
        viewBox="0 0 160 160"
        height={height}
        width={height}
        style={{ overflow: "visible" }}
        role="img"
        aria-label="Lábtica Logo"
      >
        {/* Ray 1: Turquesa #00D3CD (top vertical-ish) */}
        <rect
          x="44"
          y="6"
          width="26"
          height="54"
          rx="13"
          transform="rotate(-15 57 33)"
          fill="#00D3CD"
        />
        {/* Ray 2: Verde Caribe #00DB8F (middle angled) */}
        <rect
          x="94"
          y="28"
          width="26"
          height="54"
          rx="13"
          transform="rotate(38 107 55)"
          fill="#00DB8F"
        />
        {/* Ray 3: Verde Alien #75D300 (bottom horizontal-ish) */}
        <rect
          x="106"
          y="84"
          width="26"
          height="54"
          rx="13"
          transform="rotate(78 119 111)"
          fill="#75D300"
        />
        {/* Lowercase 'a' in bold black */}
        <path
          d="M 72 152 
             C 65 156 55 158 44 158 
             C 19 158 2 143 2 118 
             C 2 92 23 76 56 74 
             L 72 73 
             L 72 68 
             C 72 58 64 52 50 52 
             C 38 52 28 57 20 63 
             L 10 47 
             C 22 38 38 31 56 31 
             C 82 31 97 43 97 66 
             L 97 135 
             C 97 144 99 150 102 153 
             L 102 156 
             L 76 156 
             C 73 152 72 147 72 140 
             Z 
             M 72 90 
             L 58 91 
             C 39 92 27 101 27 115 
             C 27 127 37 135 49 135 
             C 60 135 69 129 72 120 
             Z"
          fill="#000000"
        />
      </svg>
      {showText && (
        <div className="sentinel-header-titles" style={{ textAlign: "left" }}>
          <h1
            className="sentinel-brand-title"
            style={{
              margin: 0,
              fontSize: "1.75rem",
              fontWeight: 800,
              letterSpacing: "-0.02em",
              color: "#000000",
              lineHeight: 1.1,
            }}
          >
            Sentinel <span style={{ color: "#00D3CD" }}>Lábtica</span>
          </h1>
          <h2
            className="sentinel-brand-subtitle"
            style={{
              margin: "4px 0 0 0",
              fontSize: "0.95rem",
              fontWeight: 500,
              color: "#475569",
              lineHeight: 1.3,
            }}
          >
            Diagnóstico de conciencia de seguridad de la información
          </h2>
        </div>
      )}
    </div>
  );
}
